import React from 'react';
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined';

const NoneSpecialEffect = {
  id: 'none',
  name: 'None',
  description: 'No special visual effects applied.',
  component: null, // No component for a "none" effect
  icon: <DoNotDisturbOnOutlinedIcon />,
  settings: {}, // No specific settings for "none"
};

export default NoneSpecialEffect; 